import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import debounce from 'lodash/debounce';

const checkPath = (path: string, matcher: RegExp | undefined) => {
  return matcher ? matcher.test(path) : true;
};

export const usePageTransition = (matcher?: RegExp) => {
  const router = useRouter();
  const [isTransitioning, setTransitioning] = useState(false);

  useEffect(() => {
    const start = debounce(
      (nextPath: string) =>
        checkPath(nextPath, matcher) && setTransitioning(true),
      200,
    );

    const complete = (nextPath: string) => {
      start.cancel();
      return checkPath(nextPath, matcher) && setTransitioning(false);
    };

    const error = (_: unknown, nextPath: string) => complete(nextPath);

    router.events.on('routeChangeStart', start);
    router.events.on('routeChangeComplete', complete);
    router.events.on('routeChangeError', error);
    return () => {
      router.events.off('routeChangeStart', start);
      router.events.off('routeChangeComplete', complete);
      router.events.off('routeChangeError', error);
    };
  }, []);

  return { isTransitioning };
};
